import { createSelector } from 'reselect';

const asFunction = v => (typeof v === 'function' ? v : () => v);
const isArray = v => v instanceof Array;
const asArray = v => (isArray(v) ? v : v === undefined ? [] : [v]);
const safeSelect = (o = {}, k) => (o !== null ? o[k] : undefined);

/**
 * Provides a safe way to select a property from a selector that returns an object
 */
export const createPropertySelector = (obj, prop) =>
  createSelector(obj, asFunction(prop), (obj = {}, prop) => {
    const result = safeSelect(
      asArray(obj).reduce((o, obj) => {
        const v = safeSelect(obj, prop);
        if (v !== undefined) {
          o[prop] = [...asArray(o[prop]), v];
        }
        return o;
      }, {}),
      prop
    );
    return result === undefined || isArray(obj) ? result : result.shift();
  });

/**
 * Provides a safe way to map a list by a property
 */
export const createReducerSelector = (obj, prop) =>
  createSelector(obj, asFunction(prop), (obj = {}, prop) =>
    asArray(obj).reduce((o, obj) => {
      try {
        if (obj === undefined || obj[prop] === undefined) return o;
        o[obj[prop]] = obj;
      } catch (e) {}
      return o;
    }, {})
  );

const safeKey = key =>
  /\W/.test(key)
    ? `[${JSON.stringify(key)}]`
    : isNaN(parseInt(key))
      ? `.${key}`
      : `[${key}]`;

export const flattenFormat = (key, parent) =>
  parent ? `${parent}${safeKey(key)}` : key;
const flatten = (
  object,
  { formatter = flattenFormat, parent = false, filter = () => true } = {}
) =>
  !object || typeof object !== 'object'
    ? {}
    : Object.keys(object).reduce(
        (o, k) => ({
          ...o,
          ...(filter(object[k], k, parent)
            ? { [formatter(k, parent)]: object[k] }
            : {}),
          ...(typeof object[k] === 'object'
            ? flatten(object[k], {
                formatter,
                filter,
                parent: formatter(k, parent)
              })
            : {})
        }),
        {}
      );

export const createFlattenSelector = (selector, options) =>
  createSelector(selector, (values = {}) => flatten(values, options));



// WEBPACK FOOTER //
// ./js/selectors/helpers.js